import React from 'react';
import ChefParallaxAccents from './ChefParallaxAccents';

const BUEN_PROVECHO =
  'https://santaplaya-bucket.s3.amazonaws.com/buenProvecho.webp';
const YONA_FULL = 'https://santaplaya-bucket.s3.amazonaws.com/Yona-Full.webp';
const PRAWN_BORDER =
  'https://santaplaya-bucket.s3.amazonaws.com/prawn_border.webp';
const ChefSection: React.FC = () => {
  return (
    // Make this container relative so absolute accents can float behind
    <section className="relative w-full flex flex-col items-center text-center py-12 px-4 sm:px-8 md:px-12">
      {/* Parallax Accents Behind */}
      <ChefParallaxAccents />

      {/* Main Foreground Content */}
      <div className="relative z-10 flex flex-col items-center w-full">
        {/* 1) Buen Provecho Image */}
        <img
          src={BUEN_PROVECHO}
          alt="Buen Provecho"
          className="mx-auto w-auto max-w-[40%]"
        />

        {/* 2) Yona-Full (80vh tall) */}
        <img
          src={YONA_FULL}
          alt="Chef Yona"
          className="mx-auto w-auto h-[80vh] object-cover my-6"
        />

        {/* 3) Funnel-like Body text in Prosto Sea */}
        <div className="flex flex-col items-center w-full">
          <p
            className="
              flex 
              flex-col 
              items-center 
              font-prosto 
              text-sea 
              text-center 
              space-y-1
              leading-tight
            "
          >
            <span className="block text-xs md:text-2xl xl:text-3xl">
              WELCOME TO SANTA PLAYA MARISCOS! MY JOUR
            </span>
            <span className="block text-xs md:text-2xl xl:text-3xl">
              -NEY HAS BEEN FUELED BY PASSION, PERSEVE-
            </span>
            <span className="block text-xs md:text-2xl xl:text-3xl">
              RANCE, AND A LOVE FOR AUTHENTIC FLAVORS. I
            </span>
            <span className="block text-xs md:text-2xl xl:text-3xl">
              INVITE YOU TO SHARE IN THE DISHES THAT HAVE
            </span>
            <span className="block text-xs md:text-2xl xl:text-3xl">
              INSPIRED ME THROUGHOUT MY TRAVELS.
            </span>
          </p>

          {/* 4) Signature line aligned right */}
          <p
            className="
              max-w-xl
              font-prosto 
              text-maroon 
              font-light 
              mt-4 
              text-sm 
              md:text-md 
              w-full 
              text-right
              pr-4
            "
          >
            - Chef Yona
          </p>
        </div>
      </div>
      <div className="flex justify-center mb-8 mt-24">
        <img
          src={PRAWN_BORDER}
          alt="Prawn Border"
          className="
            w-full
            max-w-4xl
            h-auto
            object-cover
          "
        />
      </div>
    </section>
  );
};

export default ChefSection;
